export default __webpack_public_path__ + "static/media/candidate_import.2e54849b.xlsx";